import styled from 'styled-components';
import { ConditionForm } from './form/ConditionForm';
import { ElementIndexContextProvider, ElementType } from '../../contexts/elementIndex';
import { useClauseConditionsWatch } from '../../hooks/form';
import { SearchFieldContextProvider } from './context/SearchFieldContextProvider';

const Wrapper = styled.div`
  &:not(:first-child) {
    padding-top: ${({ theme }) => theme.spacing.utils.pxToRem(0)};
  }
`;

export const ConditionsPicker = () => {
  const conditions = useClauseConditionsWatch();
  return (
    <Wrapper>
      <>
        {conditions.map((condition, i) => {
          return (
            <ElementIndexContextProvider key={condition.id} index={i} type={ElementType.condition}>
              <SearchFieldContextProvider>
                <ConditionForm />
              </SearchFieldContextProvider>
            </ElementIndexContextProvider>
          );
        })}
      </>
    </Wrapper>
  );
};
